import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '../../auth/services/app-config.service';
import { CategoriesItem } from '../categories/categories.model';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

const SNACKBAR_DURATION = 4000;

interface CategoriesNode {
  id: number;
  nombre: string;
  children?: CategoriesNode[];
}
  

@Injectable({
  providedIn: 'root'
})
export class RootcategoriesService {
  
  private backendUrl: string = `${this.appConfig.config.baseUrl}${this.appConfig.config.backendUrl}`;

  private handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }

  constructor( 
    private http: HttpClient,
    private snackbar:MatSnackBar,
    private appConfig: AppConfigService) { }

  loadCategories(): Observable<any>  {
    return this.http.get<CategoriesItem[]>(
      `${this.backendUrl}/categories`,
      {observe: 'response'}
    ).pipe(
      catchError(this.handleError)
    );
  }

  openSnacBar(message: string): void {
    this.snackbar.open(`${message}`, 'X', {
      duration: SNACKBAR_DURATION
    });
  }

  listCategories() : Observable<any> {
    return this.http.get<CategoriesItem[]>(
      `${this.backendUrl}/categories/list`,
      {observe: 'response'}
    ).pipe(
      catchError(this.handleError)
    );
  }
}
